// Application-wide constants shared across multiple files.
// Chart-specific visual calibration (margins, font ratios, etc.) stays co-located
// in chartLayout.js and individual preview components.

// Responsive
export const MOBILE_BREAKPOINT = 1024;

// Undo/redo
export const HISTORY_LIMIT = 30;

// Session persistence
export const AUTOSAVE_DEBOUNCE_MS = 1000;
export const DB_NAME = 'coplot_db';
export const DB_VERSION = 1;
export const DB_STORE = 'sessions';

// Chart canvas reference dimensions (used for proportional scaling in chartLayout.js)
export const CANVAS_REF_WIDTH = 800;
export const CANVAS_REF_HEIGHT = 520;

// Aspect ratio presets (canonical render sizes before CSS transform scaling)
export const ASPECT_RATIO_PRESETS = {
  landscape:  { width: 800,  height: 520, label: 'Landscape' },
  wide:       { width: 1120, height: 480, label: 'Wide' },
  ultrawide:  { width: 1400, height: 400, label: 'Ultra-wide' },
  standard:   { width: 720,  height: 540, label: 'Standard (4:3)' },
  square:     { width: 600,  height: 600, label: 'Square' },
  portrait:   { width: 480,  height: 720, label: 'Portrait' },
};
